(function() {
  'use strict';

  angular
    .module('admin.explore.row.service', [])
    .factory('ExploreRowTypeService', ExploreRowTypeService);

  /** @ngInject */
  function ExploreRowTypeService($http, $q, API) {

    function list(start, limit){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/row_types?start=' + start + '&limit=' + limit + '&sort=id-desc')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function listTranslations(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/row_types/' + id + '/row_type_translations')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listAll(){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/row_types')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/row_types/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function getTranslation(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/row_type_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/row_types', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createTranslation(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/row_types/' + id + '/row_type_translations?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/row_types/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/row_type_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/row_types/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/row_type_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listAll: listAll,
       listTranslations: listTranslations,
       get: get,
       getTranslation: getTranslation,
       create: create,
       createTranslation: createTranslation,
       update: update,
       updateTranslation: updateTranslation,
       remove: remove,
       removeTranslation: removeTranslation,
    };

  }

})();
